import axios from "axios";
import qs from "qs";

export enum ExperiState {
    Idle = 0, //未开始
    InProgress = 1, //进行中
    Done = 2 //结束
}

export const ExperiStateMap = {
    [ExperiState.Idle]: "未开始",
    [ExperiState.InProgress]: "进行中",
    [ExperiState.Done]: "已结束"
};

export interface ExperiListItem {
    id: number; //活动ID
    weekTimeId: number; //周次节ID
    name: string; //活动名称
    osName: string; //操作系统
    useCount: string; //预约数量
    beginTime: string; //开始时间
    endTime: string; //结束时间
    resId: string; //项目ID
    delStatus: string; //删除状态0:未删除 1:已删除
    createTime: string; //创建时间
    updateTime: string; //修改时间
    createUser: string; //创建的教师ID
    updateUser: string; //修改的ID
    useStatus: string; //使用状态0:未开始 1:进行中 2:已结束
    projectName: string; //项目名称
    url: string; //第三方实验路径
}

/**
 * 获取云桌面活动列表
 */

export function getCloudDeskTopList(weekTimeId: number) {
    return axios
        .post<SuccessData<ExperiListItem[]>>(
            "/student/cloudDeskTop/getCloudDeskTopList",
            qs.stringify({ weekTimeId })
        )
        .then(res => res.data.data);
}

/**
 * 前往实验
 */

export function goToExperimentUrl(url: string) {
    window.open(url);
}
